import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController } from '@ionic/angular';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-report',
  templateUrl: './report.page.html',
  styleUrls: ['./report.page.scss'],
})

export class ReportPage implements OnInit {

  data:any;
  url:any;
  view:any;
  type:any = 0;
  offer:any = [];
  data_type:any = 1;
  lurl:any;
  logo:any;
  user:any;
  qi:any;
  qo:any;
  unpiad = false;
  from:any;
  to:any;
  text:any;
  date:any;
 f:any;

  constructor(private socialSharing: SocialSharing,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

    if(!localStorage.getItem(Constant.userId) || localStorage.getItem(Constant.userId) == undefined || localStorage.getItem(Constant.userId) == 'null')
    {
      this.nav.navigateRoot('/home');
    }

   this.user = JSON.parse(localStorage.getItem(Constant.userData));
   this.text = JSON.parse(localStorage.getItem(Constant.appText));

  }

  ngOnInit()
  {

  }

  filterData(data)
  {
    if(this.unpiad)
    {
      if(data.invoice.paid == 0)
      {
        return true;
      }
      else
      {
        return false;
      }
    }
    else
    {
      return true;
    }
  }

  ionViewDidEnter()
  {
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }

  async loadData()
  {
    if(!this.from || !this.to)
    {
      return this.presentToast(this.text.select_field);
    }

    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.getReport(this.from,this.to).subscribe((response:any) => {
    this.data  = response.data;
    this.offer = response.offer;
    this.url   = response.url;

    loading.dismiss();

    });
  }

  shareInvoice(id)
  {
    console.log(this.url+"?id="+id);

    this.socialSharing.share("View Your Invoice From Here", 'Invoice', null, this.url+"?id="+id);
  }

  detail(invoice)
  {
    localStorage.setItem(Constant.invoiceData, JSON.stringify(invoice));

    this.nav.navigateForward('/idetail');
  }

  downloadPdf()
  {
    return window.location.href = this.server.getApiUrl()+'downloadPdf?from='+this.from+'&to='+this.to+'&token='+this.user.token;
  }
}
